import { useEffect } from 'react'
import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import Navigation from './Navigation'

const TypeformBugReport = () => {
  const navigate = useNavigate()

  useEffect(() => {
    // Load Typeform embed script
    const script = document.createElement('script')
    script.src = '//embed.typeform.com/next/embed.js'
    script.async = true
    document.body.appendChild(script)
  }, [])

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      <Navigation />
      
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-800 mb-4 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>
          
          <div className="text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Report a Bug
            </h1>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Help us improve the platform by reporting any issues you encounter. 
              Your feedback is valuable and helps us create a better experience for everyone.
            </p>
          </div>
        </div>

        {/* Typeform Embed */}
        <div className="max-w-4xl mx-auto">
          <div 
            className="bg-white rounded-lg shadow-lg p-6"
            data-tf-live="01K8PT58PV42AJ2ZEV4CFPZ1TE"
          >
            {/* Loading state */}
            <div className="flex items-center justify-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
              <span className="ml-3 text-gray-600">Loading bug report form...</span>
            </div>
          </div>
        </div>

        {/* Footer note */}
        <div className="max-w-4xl mx-auto mt-8 text-center">
          <p className="text-sm text-gray-500">
            All bug reports are reviewed by our development team. 
            We'll follow up if we need additional information.
          </p>
        </div>
      </div>
    </div>
  )
}

export default TypeformBugReport
